"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var base_taxonomy_query_class_1 = require("./base-taxonomy-query.class");

var TaxonomyQuery =
/** @class */
function (_super) {
  __extends(TaxonomyQuery, _super);

  function TaxonomyQuery(config, queryService, taxonomyCodename) {
    var _this = _super.call(this, config, queryService) || this;

    _this.config = config;
    _this.queryService = queryService;
    _this.taxonomyCodename = taxonomyCodename;

    if (!taxonomyCodename) {
      throw Error("Cannot create taxonomy query without codename of the taxonomy");
    }

    return _this;
  }
  /**
  * Gets the runnable Observable
  */


  TaxonomyQuery.prototype.getObservable = function () {
    return _super.prototype.runTaxonomyQuery.call(this, this.taxonomyCodename);
  };
  /**
  * Gets 'Url' representation of query
  */


  TaxonomyQuery.prototype.getUrl = function () {
    return _super.prototype.getTaxonomyQueryUrl.call(this, this.taxonomyCodename);
  };

  return TaxonomyQuery;
}(base_taxonomy_query_class_1.BaseTaxonomyQuery);

exports.TaxonomyQuery = TaxonomyQuery;